import { render, staticRenderFns } from "./seminar.vue?vue&type=template&id=98e0b128&scoped=true&"
import script from "./seminar.vue?vue&type=script&lang=js&"
export * from "./seminar.vue?vue&type=script&lang=js&"
import style0 from "./seminar.vue?vue&type=style&index=0&id=98e0b128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e0b128",
  null
  
)

export default component.exports